import React, { useEffect, useState } from "react";

const Modal = ({ isVisible, onClose, children }) => {
  const [showModal, setShowModal] = useState(false);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    if (isVisible !== undefined) {
      if (isVisible) {
        setShowModal(true);
        setTimeout(() => setAnimate(true), 10);
      } else {
        setAnimate(false);
        const timeout = setTimeout(() => setShowModal(false), 500);
        return () => clearTimeout(timeout);
      }
    }
  }, [isVisible]);

  if (!showModal && !isVisible) return null;

  return (
    <div
      className={`fixed z-[10] inset-0 flex justify-center items-center z-50 bg-[#000] bg-opacity-30 backdrop-blur-sm transition-all duration-500 ${animate ? "opacity-100" : "opacity-0"
        }`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      {/* Modal Content */}
      <div
        className={`bg-white w-full h-full md:h-auto md:w-[800px] md:min-w-[500px] shadow-lg mx-auto py-6 px-4 md:py-[40px] md:px-[104px] transform transition-transform duration-500 ${animate ? "scale-100" : "scale-95"
          }`}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        <div className="relative flex flex-col">
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-0 right-0 text-black hover:text-gray-800"
            aria-label="Close modal"
          >
            ✖
          </button>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
